import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const StyledDropdownItem = styled.div<{ isSelected?: boolean; isDisabled?: boolean }>`
    height: 44px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};
    padding: 0 16px;
    transition: background-color 0.2s ease;
    text-overflow: ellipsis;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    opacity: ${(props) => (props.isDisabled ? 0.5 : 1)};
    background-color: ${(props) => (props.isSelected ? colorsPalettes.bluegrey[200] : "transparent")};

    &:hover {
        background-color: ${({ isSelected }) =>
            isSelected ? colorsPalettes.bluegrey[200] : colorsPalettes.bluegrey[100]};
    }
`;

export const ItemText = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
`;

export const ItemRight = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 8px;
`;
export const Container = styled.div`
    width: 260px;
    min-width: 260px;
    height: 100%;
`;
